import project from '@/router/pto/project'

export default [
  {
    path: '/pto',
    name: 'Pto',
    component: () => import('@/views/Pto/Index.vue'),
    redirect: { name: 'PtoBuildingRegister' },
    children: [
      {
        path: 'building-register',
        name: 'PtoBuildingRegister',
        component: () => import('@/views/Pto/PtoBuildingRegister.vue')
      },
      {
        path: 'building-register/:id',
        name: 'PtoBuildingRegisterDetailed',
        component: () => import('@/views/Pto/PtoBuildingRegisterDetailed.vue')
      },
      {
        path: 'object',
        name: 'PtoObject',
        component: () => import('@/views/Pto/PtoObject.vue')
      },
      {
        path: 'object/:id',
        name: 'PtoObjectDetailed',
        component: () => import('@/views/Pto/PtoObjectDetailed.vue')
      },
      ...project,
      {
        path: 'changelog',
        name: 'PtoChangelog',
        component: () => import('@/views/Pto/PtoChangelog.vue')
      },
      {
        path: 'handbook/:handbookName',
        name: 'PtoHandbook',
        props: true,
        component: () => import('@/views/Pto/PtoHandbook.vue')
      }
    ]
  }
]
